<template>
  <v-layout v-resize="onResize" column style="padding-top: 0px">
    <div class="container-fluid">
      <v-overlay :opacity="1" :value="overlay">
        <v-progress-circular indeterminate size="64">
          Loading...
        </v-progress-circular>
      </v-overlay>
      <div class="row" style="margin-top: 0px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Inquiry Data</div>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <v-select :items="listKotaDaftar" label="Tao Ying City" required v-model="search_kota"
                    item-text="DESKRIPSI_DATA" item-value="ID_DATA" color="#F9A825"></v-select>
                </div>
                <div class="col">
                  <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="search_tgl_daftar" label="Tao Ying Start Date" prepend-icon="mdi-calendar"
                        readonly v-bind="attrs" @blur="search_tgl_daftar_raw = parseDate(search_tgl_daftar)" v-on="on"
                        color="#F9A825"></v-text-field>
                    </template>
                    <v-date-picker v-model="search_tgl_daftar_raw" color="#F9A825" @input="menu2 = false">
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="col">
                  <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs2 }">
                      <v-text-field v-model="search_tgl_daftar2" label="Tao Ying End Date" prepend-icon="mdi-calendar"
                        readonly v-bind="attrs2" @blur="search_tgl_daftar_raw2 = parseDate(search_tgl_daftar2)"
                        v-on="on" color="#F9A825"></v-text-field>
                    </template>
                    <v-date-picker v-model="search_tgl_daftar_raw2" color="#F9A825" @input="menu3 = false">
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <v-select :items="listKotaDaftar" label="Kota Pelantikan" required v-model="search_kota_pelantikan"
                    item-text="DESKRIPSI_DATA" item-value="ID_DATA" color="#F9A825"></v-select>
                </div>
                <div class="col">
                  <v-menu v-model="menu4" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs3 }">
                      <v-text-field v-model="search_tgl_daftar3" label="Tanggal Pelantikan Start Date"
                        prepend-icon="mdi-calendar" readonly v-bind="attrs3"
                        @blur="search_tgl_daftar_raw3 = parseDate(search_tgl_daftar3)" v-on="on" color="#F9A825">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="search_tgl_daftar_raw3" color="#F9A825" @input="menu4 = false">
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="col">
                  <v-menu v-model="menu5" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs4 }">
                      <v-text-field v-model="search_tgl_daftar4" label="Tanggal Pelantikan End Date"
                        prepend-icon="mdi-calendar" readonly v-bind="attrs4"
                        @blur="search_tgl_daftar_raw4 = parseDate(search_tgl_daftar4)" v-on="on" color="#F9A825">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="search_tgl_daftar_raw4" color="#F9A825" @input="menu5 = false">
                    </v-date-picker>
                  </v-menu>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <v-select :items="listSuku" item-text="DESKRIPSI_DATA" item-value="ID_DATA"
                    label="Ethnicity / Suku (民族)" required v-model="search_suku"></v-select>
                </div>
                <div class="col">
                  <v-select :items="listGoldar" item-text="DESKRIPSI_DATA" item-value="ID_DATA"
                    label="Blood Type / Golongan Darah 血型" required v-model="search_goldar"></v-select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <v-select :items="listStatus" item-text="DESKRIPSI_DATA" item-value="ID_DATA" label="Status 婚姻状况*"
                    required v-model="search_status"></v-select>
                </div>
                <div class="col">

                  <v-select :items="listGender" label="Gender / Jenis Kelamin 性别*" v-model="search_kelamin">
                  </v-select>

                </div>
              </div>
              <div class="row">
                <div class="col">
                  <v-select :items="listPendidikan" item-text="DESKRIPSI_DATA" item-value="ID_DATA"
                    label="Education / Pendidikan 教育程度" required v-model="search_pendidikan"></v-select>
                </div>
                <div class="col">
                  <v-select :items="listPekerjaan" item-text="DESKRIPSI_DATA" item-value="ID_DATA"
                    label="Occupation / Pekerjaan 职业" required v-model="search_job"></v-select>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <v-select :items="listKotaTgl" item-text="DESKRIPSI_DATA" item-value="ID_DATA"
                    label="Residence City / Kota Domisili 居住市" required v-model="search_kota_dom"></v-select>
                </div>
                <div class="col">
                  <v-select :items="listData" label="Tipe Data" v-model="search_tipe_data"></v-select>
                </div>
              </div>
              <div class="row">
                <div class="col">

                  <v-select :items="listOrder" label="Order by" v-model="search_order">
                  </v-select>

                </div>
              </div>
              <div class="row">
                <div class="col">

                  <v-select :items="listFlag" label="Flag Anggota" v-model="search_flag">
                  </v-select>

                </div>
              </div>
              <div class="row">
                <v-btn x-small style="margin: 10px; float: left; background-color: #fcc133" @click="onReset">Clear
                </v-btn>
                <v-btn x-small style="margin: 10px; float: left; background-color: #3eb650" @click="onPrint">Print PDF
                </v-btn>
                <v-btn x-small style="margin: 10px; float: left; background-color: #3eb650" @click="onPrintCSV">Print
                  CSV</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
import 'fix-date'
import axios from '@/axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    data: () => ({
        overlay:false,
        search: '',
        search_kota: '',
        search_kota_pelantikan: '',
        search_tgl_daftar:'',
        search_tgl_daftar_raw: '',
        search_tgl_daftar2: '',
        search_tgl_daftar_raw2: '',
        search_tgl_daftar3: '',
        search_tgl_daftar_raw3: '',
        search_tgl_daftar4: '',
        search_tgl_daftar_raw4: '',
        search_kota_dom: '',
        search_order:'',
        search_pendidikan:'',
        search_kelamin: '',
        search_flag: '',
        search_job:'',
        search_suku:'',
        search_tipe_data:'',
        search_status:'',
        search_goldar:'',
        menu2: false,
        menu3: false,
        menu4: false,
        menu5: false,
        dialog: false,
        listKotaDaftar:[],
        listGender: [{ text: 'All Gender', value: '' }, { text: 'Man 男', value: 'L' }, { text: 'Woman 女', value: 'P' }],
        listFlag: [{ text: 'All', value: '' }, { text: 'Yes', value: '1' }, { text: 'No', value: '2' }],
        listOrder: [{ text: 'Nomor Huangyi / Nomor Taoyu', value: 'no_anggota' }, { text: 'Nama Indo', value: 'nama_indo' }, { text: 'Nama Pinyin', value: 'nama_pinyin' }, { text: 'Kota Domisili', value: 'kota_dom' }],
        listStatus:[],
        listPekerjaan:[],
        listPendidikan:[],
        listGoldar:[],
        listSuku:[],
        users:[],
        isMobile: false,
        editedIndex:'',
        listData: ['','Taoyu','HuangYi'],
        listKotaTgl:[],
        flagEdited:false,
        role:0,
        singleSelect: false,
        dataTables: [],
    }),
    watch: {
        dialog (val) {val || this.close()},
        search_tgl_daftar_raw (val) {
          // alert(val);
            this.search_tgl_daftar = this.formatDate(this.search_tgl_daftar_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
        search_tgl_daftar_raw2(val) {
          this.search_tgl_daftar2 = this.formatDate(this.search_tgl_daftar_raw2)
          // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
        search_tgl_daftar_raw3(val) {
          this.search_tgl_daftar3 = this.formatDate(this.search_tgl_daftar_raw3)
          // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
        search_tgl_daftar_raw4(val) {
          this.search_tgl_daftar4 = this.formatDate(this.search_tgl_daftar_raw4)
          // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
    },
    created () {
        this.initialize()
    },
    beforeCreate: function () {
        if (!this.$session.exists()) {
        this.$router.push('/')
        }
    },
    methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else{

            this.isMobile = false;
          }
        },
      onPrint() {
          if (this.search_tgl_daftar_raw2 < this.search_tgl_daftar_raw) {
                   Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Tanggal Taoying End Date Tidak Boleh Lebih Kecil dari Start Date'
                            });
            // alert("TANGGAL TAOYING END DATE TIDAK BOLEH LEBIH KECIL DARI START DATE");
          } else {
            if (this.search_tgl_daftar_raw4 < this.search_tgl_daftar_raw3) {
              Swal.fire({
                title: 'Peringatan',
                icon: 'error',
                text: 'Tanggal Pelantikan End Date Tidak Boleh Lebih Kecil dari Start Date'
              });
              // alert("TANGGAL PELANTIKAN END DATE TIDAK BOLEH LEBIH KECIL DARI START DATE");
            } else {
              if(this.search_kota_dom!=="" || this.search_kota_tao!=="")
                {
                     this.overlay=true;
                    axios({
                        method: 'post',
                        url: 'cetak_report',
                        responseType: 'blob', // important
                        data: {
                          kota_dom:this.search_kota_dom,
                          tgl_taoying_start_date: this.search_tgl_daftar,
                          tgl_taoying_end_date: this.search_tgl_daftar2,
                          tgl_pelantikan_start_date: this.search_tgl_daftar3,
                          tgl_pelantikan_end_date: this.search_tgl_daftar4,
                          kota_tao: this.search_kota,
                          kota_pelantikan: this.search_kota_pelantikan,
                          pendidikan:this.search_pendidikan,
                          kelamin:this.search_kelamin,
                          pekerjaan:this.search_job,
                          suku:this.search_suku,
                          status:this.search_status,
                          goldar:this.search_goldar,
                          tipe_data: this.search_tipe_data,
                          flag_anggota: this.search_flag,
                          order_by: this.search_order,
                          tipe: 'pdf'
                        },
                        headers: {
                          Authorization: 'Bearer ' + this.$session.get('token'),
                        },
                    }).then(response => {
                            // alert(response.data);
                        if(response){
                        var today = new Date();
                        var dd = String(today.getDate()).padStart(2, '0');
                        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                        var yyyy = today.getFullYear();
                        // d.getHours()+":"+d.getMinutes()+":"+d.getSeconds();
                        var jam = today.getHours();
                        var menit = today.getMinutes();
                        var detik = today.getSeconds();
                        today = dd + '-' + mm + '-' + yyyy +  ' ' + jam + menit + detik;
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', 'Report '+today+'.pdf');
                            document.body.appendChild(link);
                            link.click();
                        }
                        this.overlay=false
                    }).catch(error => {

                     Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Data Kosong'
                            });
                      this.overlay=false
                    });
                     

                }else{
                   Swal.fire({
                                    title:'Peringatan',
                                    icon :'error',
                                    text:'Pilih Data Kota Tao atau Kota Domisili'
                            });
                }
            }
          }
          
                

        },
        onPrintCSV(){

                this.overlay=true
                axios({
                    method: 'post',
                    url: 'cetak_report',
                    responseType: 'blob', // important
                    data: {
                      kota_dom:this.search_kota_dom,
                      tgl_taoying_start_date: this.search_tgl_daftar,
                      tgl_taoying_end_date: this.search_tgl_daftar2,
                      tgl_pelantikan_start_date: this.search_tgl_daftar3,
                      tgl_pelantikan_end_date: this.search_tgl_daftar4,
                      kota_tao:this.search_kota,
                      pendidikan:this.search_pendidikan,
                      kelamin:this.search_kelamin,
                      pekerjaan:this.search_job,
                      suku:this.search_suku,
                      status:this.search_status,
                      goldar:this.search_goldar,
                      tipe_data: this.search_tipe_data,
                      order_by: this.search_order,
                      tipe: 'csv'
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                        // alert(response.data);
                    if(response){
                        var today = new Date();
                        var dd = String(today.getDate()).padStart(2, '0');
                        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                        var yyyy = today.getFullYear();
                        // d.getHours()+":"+d.getMinutes()+":"+d.getSeconds();
                        var jam = today.getHours();
                        var menit = today.getMinutes();
                        var detik = today.getSeconds();
                        today = dd + '-' + mm + '-' + yyyy +  ' ' + jam + menit + detik;
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Report '+today+'.csv');
                        document.body.appendChild(link);
                        link.click();
                    }
                    this.overlay=false
                }).catch(error => {

                 Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Data Kosong'
                        });
                 this.overlay=false
                });



        },
        onReset(){
          this.search_kota_dom=''
          this.search_tgl_daftar = ''
          this.search_tgl_daftar2 = ''
          this.search_tgl_daftar3 = ''
          this.search_tgl_daftar4= ''
          this.search_kota=''
          this.search_pendidikan=''
          this.search_kelamin=''
          this.search_job=''
          this.search_suku=''
          this.search_status=''
          this.search_goldar=''
          this.search_tipe_data = ''
          this.search_order = ''
          this.search_kota_pelantikan = ''
        },
        formatDate (val) {
          if (!val) {
            return null
          } else {
            return new Date(val).toLocaleDateString('es-CL');

          }
        },
        parseDate (val) {
          if (val !== null && typeof (val) !== 'undefined') {
            return new Date(val).toISOString().substr(0, 10)
          } else {
            return null
          } 
            // return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        close () {
            this.dialog = false
            this.$nextTick(() => {
                this.editedIndex = -1
            })
        },
        searchData(){
            // alert(this.search_kota+' '+this.search_tgl_daftar);
            // alert('Search Here '+this.search_kota+' '+this.search_tgl_daftar_raw);

            if(this.search_kota!=='' || this.search_tgl_daftar_raw!==''){
                // alert("here");
                axios({
                    method: 'post',
                    url: 'get_data_taoyu_s',
                    data: {
                      kota: this.search_kota,
                      tanggal: this.search_tgl_daftar_raw,
                      nomor_taoyu: this.search
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    this.users=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }
        },
        onCloseDialog(){
            this.dialog2=false;
            this.dialog = false;
            this.initialize()
        },
        initialize(){
            axios({
                method: 'post',
                url: 'master_data_by_admin',
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
                data:{
                    user_id:  this.$session.get('user_id')
                }
            }).then(response => {

                this.listKota=response.data.Kota_Daftar;
                this.listKotaDaftar=response.data.Kota_Daftar;
                this.listSuku=response.data.Suku;
                this.listStatus=response.data.Status;
                this.listPendidikan=response.data.Pendidikan;
                this.listPekerjaan=response.data.Pekerjaan;
                this.listGoldar=response.data.Golongan_Darah;
                this.listKotaTgl=response.data.Kota_Domisili;

            }).catch(error=>{
                  Swal.fire({
                                title:'Peringatan',
                                icon :'error',
                                text:'Failed to retrieve data !'
                        });



            });
        },
    },
    components: {

    },
}
</script>

<style>
.butt {
  padding: 10px;
  background-color: #ebaa1f;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
